import { Footer } from 'rsuite';

import React from 'react';

function FooterComponent() {
  return <Footer className="db-footer text-center">Copyright © 2021 SoulRooms - All Rights Reserved.</Footer>;
}

export default FooterComponent;
